var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import classnames from 'classnames';
import { extractTextFromReact } from '../../../utils/extractTextFromReact';
import styles from './TabsButton.module.scss';
const TabsButton = forwardRef((_a, ref) => {
    var _b;
    var { value, selectedValue, disabled = false, onClickCallback, className, fullWidth, theme = 'default', children } = _a, props = __rest(_a, ["value", "selectedValue", "disabled", "onClickCallback", "className", "fullWidth", "theme", "children"]);
    const ariaLabel = (_b = props['aria-label']) !== null && _b !== void 0 ? _b : extractTextFromReact(children);
    return (_jsx("button", Object.assign({}, props, { ref: ref, "aria-label": ariaLabel, type: "button", role: "tab", onClick: handleClickButton, className: classnames(styles.button, className, styles[theme], { [styles.selected]: value === selectedValue, [styles.fullWidth]: fullWidth }) }, { children: children })));
    function handleClickButton() {
        if (typeof onClickCallback !== 'function' || disabled || value === selectedValue) {
            return;
        }
        onClickCallback(value);
    }
});
TabsButton.displayName = 'TabsButton';
export default TabsButton;
